import React from 'react'
import { ButtonConfig } from 'interfaces/quota/';


interface Props {
    confirmButtonConfig: ButtonConfig
}

export const Button: React.FC<Props> = ({ confirmButtonConfig }) => {

    const handleOnclickSimular = () => {
        if (confirmButtonConfig.disabled) {
            return
        }
        confirmButtonConfig.action()
    }

    return (
        <div className='bp-my-20 flex-center'>
            <button
                className='sizebutton-loan simulator-button'
                id="simular-button"
                onClick={handleOnclickSimular}
                disabled={confirmButtonConfig.disabled}
                style={{background:confirmButtonConfig.disabled?'#9FA8BE':'#0f265c'}}
            >
                {confirmButtonConfig.value}
            </button>
        </div>
    );
}
